import { FC, Fragment, HTMLAttributes, ReactNode } from "react";
import clsx from "clsx";

import HtmlText from "../common/HtmlText";
import TButton from "@/components/atoms/buttons/TButton";
import { ITextButton } from "@/components/atoms/buttons/types";

// -----------------------------------------------------------------------

export type ICoursePlanProps = HTMLAttributes<HTMLElement> & {
  heading?: string;
  weeks?: { heading?: string; description: ReactNode }[];
  button?: ITextButton;
};

const CoursePlan: FC<ICoursePlanProps> = (props) => {
  const { heading, weeks, button, className, ...other } = props;

  return (
    <section
      className={clsx("py-5 lg:py-8 xl:py-[50px]", className)}
      {...other}
    >
      <div className="container">
        {heading && (
          <h2 className="mb-5 text-center text-3xl font-medium text-black-900 dark:text-white lg:text-h2">
            {heading}
          </h2>
        )}

        {weeks && weeks.length > 0 && (
          <div className="relative grid grid-cols-1 gap-y-7 md:gap-y-10 lg:grid-cols-[1fr_1fr] lg:gap-x-8 lg:gap-y-0">
            <div className="absolute left-2/4 h-full -translate-x-2/4">
              <div className="relative hidden h-full w-[3px] flex-col bg-black-800 lg:mx-3.5 lg:flex xl:mx-3">
                <span className="sticky top-0 block h-[764px] w-[3px] bg-yellow-400"></span>
                <span className="before:absolute before:-left-1.5 before:-top-1 before:block before:size-4 before:rounded-full before:bg-yellow-400"></span>
              </div>
            </div>

            {weeks.map((item, idx) => (
              <Fragment key={idx}>
                <div
                  className={clsx(
                    "bg-secondary-50 p-5 !pr-0 last:mb-10 dark:bg-black-800 md:p-8 lg:p-10 xl:p-12",
                    idx === 0 && "mt-5 lg:mt-20",
                    idx !== 0 && "lg:relative lg:-mt-[145px]",
                  )}
                >
                  <h3 className="border-b-2 border-yellow-400 pb-5 pr-5 text-h6 font-normal text-black-900 dark:text-white lg:pb-7 lg:text-h5 xl:text-h4">
                    {item.heading}
                  </h3>
                  <HtmlText className="mt-[30px] pr-5">
                    {item.description}
                  </HtmlText>
                </div>
                {idx % 2 === 0 && (
                  <>
                    <div className="hidden lg:block"></div>
                    <div className="hidden lg:block"></div>
                  </>
                )}
              </Fragment>
            ))}
          </div>
        )}
        {button && (
          <div className="flex justify-center">
            <TButton
              id={button.id}
              variant={button.variant}
              href={button.link}
              target={button.target}
              radius={button.radius}
            >
              {button.text}
            </TButton>
          </div>
        )}
      </div>
    </section>
  );
};

export default CoursePlan;
